import { render, staticRenderFns } from "./AppointmentFilters.vue?vue&type=template&id=51573c02&"
import script from "./AppointmentFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppointmentFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51573c02')) {
      api.createRecord('51573c02', component.options)
    } else {
      api.reload('51573c02', component.options)
    }
    module.hot.accept("./AppointmentFilters.vue?vue&type=template&id=51573c02&", function () {
      api.rerender('51573c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/AppointmentFilters/AppointmentFilters.vue"
export default component.exports